var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "url(#paint0_linear_11_105)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11_105)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0001,
    r: 7,
    fill: "url(#paint1_linear_11_105)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11_105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2966 10.6886C14.238 11.0636 13.8888 11.4776 13.2202 11.4776H10.8012L11.0454 9.91187H13.4631C14.1317 9.91187 14.3542 10.3142 14.2966 10.6886ZM10.6 12.7769H12.592L13.5515 15.0256C13.6445 15.2536 13.8498 15.4 14.2195 15.4C14.6881 15.4 15.0679 15.0657 15.1303 14.6638C15.1507 14.5299 15.129 14.3963 15.0736 14.2896L14.3354 12.5496C15.328 12.2012 15.8466 11.5176 15.9733 10.7008C16.1545 9.53822 15.4468 8.60004 13.4127 8.60004H10.3969C9.92694 8.60004 9.48664 8.96099 9.41851 9.40282L8.60955 14.5976C8.54141 15.0385 8.86933 15.4 9.33892 15.4C9.80883 15.4 10.2498 15.0385 10.3179 14.5976L10.6 12.7769Z",
    fill: "url(#paint2_linear_11_105)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11_105",
    x: 5,
    y: 5.00006,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11_105"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11_105",
    x: 3.85059,
    y: 8.60004,
    width: 16.8999,
    height: 16.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_105",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_105",
    x1: 12,
    y1: 5.00006,
    x2: 12,
    y2: 19.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A22D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_105",
    x1: 12.3006,
    y1: 8.60004,
    x2: 12.3006,
    y2: 15.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FFD05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD05B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCoin);
export default __webpack_public_path__ + "static/media/gold_coin.54afe0f3684fdfceacdc02335513de09.svg";
export { ForwardRef as ReactComponent };